<template>
    <div class="configurator-your-bike container">
        <MainTitle v-if="bikeName" :title="$t('yourBike.mainTitle', { modelName: bikeName })"
            :titleHead="$t('yourBike.mainTitleHead')" id="your_bike" class="mb-lg-5 text-center" />

        <div class="row mb-5" v-if="bikeName">
            <div class="col-lg-7">
                <BikePicture :url="bikeImage" />
            </div>

            <div class="col-lg-5 p-5r">
                <div class="your-bike-sub-title mb-4">{{ $t('yourBike.buyTitle') }}</div>

                <div class="your-bike-merchant row p-3 no-gutters mb-2">
                    <div class="col-2"><i class="fal fa-store your-bike-merchant-icon ml-2"></i></div>
                    <div class="col-10">
                        <div class="your-bike-merchant-title">{{ $t('yourBike.buyMerchantTitle') }}</div>
                        <div class="your-bike-merchant-title-text mb-4">{{ $t('yourBike.buyMerchantTitleText') }}</div>
                        <div class="your-bike-merchant-text">{{ $t('yourBike.buyMerchantText') }}</div>
                        <div class="your-bike-merchant-configurations-number mb-3"><a href="#" class="copy-key"
                                v-on:click="copyKey($event)" title="Konfigurationsnummer in Zwischenablage kopieren">{{
                                    configKey }}</a></div>
                        <div class="your-bike-merchant-link">
                            <button data-toggle="modal" data-target="#selectModal" class="btn btn-secondary">{{
                                $t('yourBike.buyMerchantLink') }}</button>
                        </div>
                    </div>
                </div>

                <a href="#" v-if="checkCartAvailability()" v-on:click="sendDataToCart"
                    class="btn btn-primary btn-block p-3 your-bike-shopping-cart text-left">
                    <div class="row no-gutters">
                        <div class="col-2"><i class="fal fa-shopping-cart your-bike-shopping-cart-icon ml-2"></i></div>
                        <div class="col-10">
                            <div class="your-bike-shopping-cart-title">{{ $t('yourBike.buyCartTitle') }}</div>
                            <div class="your-bike-shopping-cart-text">{{ $t('yourBike.buyCartText') }}</div>
                        </div>
                    </div>
                </a>
            </div>
        </div>

        <!--
        <div class="row mb-5" v-if="bikeName">
            <div class="col-lg-8">
                <BikePicture :url="bikeImage" />
            </div>

            <div class="col-lg-4 p-5 your-bike-configurations-container">
                <div class="your-bike-configurations-number-text">{{ $t('yourBike.configurationNumberText') }}</div>
                <div class="your-bike-configurations-number"><a href="#" class="copy-key" v-on:click="copyKey($event)" title="Konfigurationsnummer in Zwischenablage kopieren">{{ configKey }}</a></div>
                <div class="your-bike-configurations-description">{{ $t('yourBike.configurationNumberDescription') }}</div>

                <hr />

                <div class="your-bike-configurations-comment-text">{{ $t('yourBike.descriptionTitle') }}</div>
                <textarea class="your-bike-configurations-comment" cols="40" rows="5" :placeholder="$t('yourBike.descriptionPlaceholder')" v-model="comment" maxlength="256"></textarea>

                <button class="your-bike-configurations-comment-button btn" v-on:click="saveConfiguration">{{ $t('yourBike.descriptionSaveButton') }}</button>

                <a href="#" onclick="print()" class="your-bike-configurations-print-link"><i class="fal fa-print"></i> {{ $t('yourBike.printLink') }}</a>


                <button class="btn" v-on:click="sendDataToCart">In den Warenkorb</button>
            </div>
        </div>-->

        <SubTitle v-if="bikeName" :title="$t('yourBike.subTitle1')" id="equipment" />

        <div class="row" v-if="HeaderData">
            <div class="col-md-4 mt-4" v-for="(item, index) in HeaderData['Reihenfolge']">
                <div class="your-bike-equipment-container p-4">
                    <b class="mb-1">{{ HeaderData[item] }}</b><br />

                    <div v-if="item === 'Ausstattung'">{{ $t('yourBike.equipment') }}</div>
                    <div v-else-if="item === 'Rahmenfarbe'">{{ $t('yourBike.frameColor') }}</div>
                    <div v-else-if="item === 'Rahmengröße'">{{ $t('yourBike.frameSize') }}</div>
                    <div v-else-if="item === 'Dekor'">{{ $t('yourBike.decor') }}</div>
                    <div v-else-if="item === 'Klarlack'">{{ $t('yourBike.clearVarnish') }}</div>
                    <div v-else>{{ item }}</div>

                    <div class="your-bike-equipment-container-color" v-if="item === 'Rahmenfarbe'"
                        :style="'background-color: #' + HeaderData['ColorCode']"></div>
                    <div class="your-bike-equipment-container-base-price" v-if="item === 'Ausstattung'">
                        {{ formatPrice(HeaderData['Grundpreis']) }} {{ $t('yourBike.basePrice') }}
                    </div>

                </div>
            </div>
        </div>

        <div class="row">
            <div v-for="item in StandardData" class="col-md-6 col-xl-4 mt-4">
                <div class="your-bike-item-container p-4" :class="{ 'space-bottom': item.InfoImage }">
                    <div class="your-bike-item-title mb-2">{{ item['Characteristic'] }}</div>
                    <div class="your-bike-item-value mb-1">{{ item['Value'] }}
                        <span v-if="item.Price" style="font-weight: 500;">(+&nbsp;{{ formatPrice(item.Price) }})</span>
                    </div>
                    <div v-if="item.InfoText && item.InfoText.length > 200" class="your-bike-item-text read-more-text"
                        v-html="item.InfoText">{{ item['InfoText'] }}</div>
                    <div v-if="item.InfoText && item.InfoText.length < 200" class="your-bike-item-text"
                        v-html="item.InfoText">{{ item['InfoText'] }}</div>

                    <div class="your-bike-item-action-container" v-if="item.InfoText && item.InfoText.length > 200">
                        <a href="#" :ref="'readMore_' + item.ID" class="your-bike-item-read-more"
                            v-on:click="toggleRead($event, 'more', item.ID)">{{ $t('yourBike.readMore') }} <i
                                class="fas fa-angle-down"></i></a>
                        <a href="#" :ref="'readLess_' + item.ID" class="your-bike-item-read-less"
                            v-on:click="toggleRead($event, 'less', item.ID)">{{ $t('yourBike.readLess') }} <i
                                class="fas fa-angle-up"></i></a>
                    </div>

                    <div class="your-bike-item-image" v-if="item.InfoImage">

                        <v-lazy-image :src="item.InfoImage" />
                    </div>
                </div>
            </div>
        </div>

        <SubTitle v-if="checkOptions(OptionData)" :title="$t('yourBike.subTitle2')" id="more_options" />

        <div v-if="checkOptions(OptionData)" class="row">
            <div v-for="item in OptionData" class="col-md-6 col-xl-4 mt-4">
                <div class="your-bike-item-container p-4" :class="{ 'space-bottom': item.InfoImage }">
                    <div class="your-bike-item-title mb-2">{{ item['Characteristic'] }}</div>
                    <div class="your-bike-item-value mb-1">{{ item['Value'] }}
                        <span v-if="item.Price" style="font-weight: 500;">(+&nbsp;{{ formatPrice(item.Price) }})</span>
                    </div>
                    <div v-if="item.InfoText && item.InfoText.length > 200" class="your-bike-item-text read-more-text"
                        v-html="item.InfoText">{{ item['InfoText'] }}</div>
                    <div v-if="item.InfoText && item.InfoText.length < 200" class="your-bike-item-text"
                        v-html="item.InfoText">{{ item['InfoText'] }}</div>

                    <div class="your-bike-item-action-container" v-if="item.InfoText && item.InfoText.length > 200">
                        <a href="#" :ref="'readMore_' + item.ID" class="your-bike-item-read-more"
                            v-on:click="toggleRead($event, 'more', item.ID)">{{ $t('yourBike.readMore') }} <i
                                class="fas fa-angle-down"></i></a>
                        <a href="#" :ref="'readLess_' + item.ID" class="your-bike-item-read-less"
                            v-on:click="toggleRead($event, 'less', item.ID)">{{ $t('yourBike.readLess') }} <i
                                class="fas fa-angle-up"></i></a>
                    </div>

                    <div class="your-bike-item-image" v-if="item.InfoImage">

                        <v-lazy-image :src="item.InfoImage" />
                    </div>
                </div>
            </div>
        </div>

        <SubTitle v-if="checkOptions(AccessoriesData)" :title="$t('yourBike.subTitle3')" id="accessories" />

        <div v-if="checkOptions(AccessoriesData)" class="row">
            <div v-for="item in AccessoriesData" class="col-md-6 col-xl-4 mt-4">
                <div class="your-bike-item-container p-4" :class="{ 'space-bottom': item.InfoImage }">
                    <div class="your-bike-item-title mb-2">{{ item['Characteristic'] }}</div>
                    <div class="your-bike-item-value mb-1">{{ item['Value'] }}
                        <span v-if="item.Price" style="font-weight: 500;">(+&nbsp;{{ formatPrice(item.Price) }})</span>
                    </div>
                    <div v-if="item.InfoText && item.InfoText.length > 200" class="your-bike-item-text read-more-text"
                        v-html="item.InfoText">{{ item['InfoText'] }}</div>
                    <div v-if="item.InfoText && item.InfoText.length < 200" class="your-bike-item-text"
                        v-html="item.InfoText">{{ item['InfoText'] }}</div>

                    <div class="your-bike-item-action-container" v-if="item.InfoText && item.InfoText.length > 200">
                        <a href="#" :ref="'readMore_' + item.ID" class="your-bike-item-read-more"
                            v-on:click="toggleRead($event, 'more', item.ID)">{{ $t('yourBike.readMore') }} <i
                                class="fas fa-angle-down"></i></a>
                        <a href="#" :ref="'readLess_' + item.ID" class="your-bike-item-read-less"
                            v-on:click="toggleRead($event, 'less', item.ID)">{{ $t('yourBike.readLess') }} <i
                                class="fas fa-angle-up"></i></a>
                    </div>

                    <div class="your-bike-item-image" v-if="item.InfoImage">

                        <v-lazy-image :src="item.InfoImage" />
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="selectModal" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <i class="fal fa-times"></i> Schließen
                        </button>
                    </div>
                    <div class="modal-body">

                        <div class="storerocket-store-locator"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
// @ is an alias to /src
import MainTitle from '@/components/MainTitle.vue'
import BikePicture from '@/components/BikePicture.vue'
import SubTitle from '@/components/SubTitle.vue'
import VLazyImage from "v-lazy-image";

export default {
    name: 'your_bike',
    components: {
        MainTitle,
        BikePicture,
        SubTitle,
        VLazyImage
    },
    data() {
        return {
            bikeName: '',
            bikeImage: '',
            configKey: '',
            comment: '',
            HeaderData: [],
            StandardData: [],
            OptionData: [],
            AccessoriesData: [],
            priceRaw: 0,
            confetti: 0,
            confetti2: 0,
            priceSymbol: '',
            orderNumber: 0
        }
    },
    methods: {
        formatPrice(value) {

            let val = (value / 1).toFixed(2).replace('.', ',')
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ' ' + this.$parent.priceSymbol;
        },
        toggleRead: function (event, state, category) {
            event.preventDefault();

            if (state === "more") {
                let readMore = this.$refs['readMore_' + category];
                $(readMore).hide();
                $(readMore).parent().siblings('.your-bike-item-text').css({ 'height': 'auto', 'max-height': '300px', 'overflow-y': 'auto' });
                $(readMore).siblings('.your-bike-item-read-less').show();
            } else if (state === "less") {
                let readLess = this.$refs['readLess_' + category];
                $(readLess).hide();
                $(readLess).parent().siblings('.your-bike-item-text').css({ 'height': '85px', 'margin-bottom': '0', 'overflow-y': 'hidden' });
                $(readLess).siblings('.your-bike-item-read-more').show();
            }
        },
        checkOptions: function (options) {
            if (options && options.length > 0) {
                return true;
            } else {
                return false;
            }
        },
        checkCartAvailability: function () {
            // B2C: EUR und CHF
            if (this.$parent.channel === 'b2c') {
                return this.priceSymbol === 'EUR' || this.priceSymbol === 'CHF' || this.priceSymbol === 'USD';
            }
            // B2B: EUR, CHF und USD
            else if (this.$parent.channel === 'b2b') {
                return this.priceSymbol === 'EUR' || this.priceSymbol === 'CHF' || this.priceSymbol === 'USD';
            }
            // Fallback für unbekannte Channels
            return this.priceSymbol === 'EUR' || this.priceSymbol === 'CHF' || this.priceSymbol === 'USD';
        },
        copyKey: function (e) {
            e.preventDefault();

            let ta = document.createElement('textarea');
            ta.value = this.configKey;
            document.body.appendChild(ta);
            ta.select();
            document.execCommand('copy');
            document.body.removeChild(ta);
        },
        getOverview: function () {
            let app = this;
            let parent = app.$parent;
            let params = new URLSearchParams();
            let errorCounter = 0;
            params.append('apikey', this.$apikey);
            params.append('apipassword', this.$apipassword);
            params.append('ConfigurationID', parent.ConfigurationID);
            params.append('CustomerID', parent.customerID);
            parent.popupError = false;

            app.getOverviewPost(app, parent, params, errorCounter);
        },
        getOverviewPost(app, parent, params, errorCounter) {
            this.$http.post(this.$apiurl + '/api/GetOverview', params)
                .then(response => {
                    this.HeaderData = response.data['ReturnData']['HeaderData'];

                    this.StandardData = response.data['ReturnData']['StandardData'];
                    if (response.data['ReturnData']['OptionData']) this.OptionData = response.data['ReturnData']['OptionData'];
                    this.AccessoriesData = response.data['ReturnData']['AccessoriesData'];
                    this.configKey = response.data['TransferData']['ConfigKey'];
                    this.orderNumber = response.data['TransferData']['Article'];

                    app.bikeName = response.data['TransferData']['ModelName'];
                    app.bikeImage = response.data['TransferData']['Image'];
                    if (response.data['TransferData']['Price']) {
                        app.priceRaw = response.data['TransferData']['Price'];
                        app.$parent.price = response.data['TransferData']['Price'].toFixed(2).replace('.', ',') + ' ' + parent.priceSymbol;
                        app.priceSymbol = response.data['TransferData']['PriceSymbol'];
                    }
                    $('#nextButton').addClass('d-none');

                    this.$parent.loading = false;

                    ga('create', 'UA-25371094-9', 'configurator.tout-terrain.de');
                    ga('send', 'event', 'KonfigurationRad', 'abgesendet', this.configKey, response.data['TransferData']['Price']);

                    this.startConfetti();
                })
                .catch(error => {
                    if (error.response.status === 500) {
                        errorCounter++;
                        if (errorCounter <= 25) {
                            setTimeout(function () {
                                app.getOverviewPost(app, parent, params, errorCounter);
                            }, 250)
                        } else {
                            parent.popupError = true;
                        }
                    } else {
                        parent.popupError = true;
                    }
                })
        },
        saveConfiguration: function (e) {
            e.preventDefault();
            let app = this;
            let parent = app.$parent;
            let params = new URLSearchParams();
            params.append('apikey', this.$apikey);
            params.append('apipassword', this.$apipassword);
            params.append('ConfigurationID', parent.ConfigurationID);
            params.append('CustomerID', parent.customerID);
            if (app.comment !== '') params.append('Value', app.comment);

            app.saveConfigurationPost(app, parent, params);
        },
        saveConfigurationPost(app, parent, params) {
            this.$http.post(this.$apiurl + '/api/SaveConfig/', params)
                .then(response => {
                    parent.popupSuccess = true;
                    parent.popupSuccessText = response.data['TransferData']['Message'];

                    this.configKey = response.data['TransferData']['ConfigKey'];
                })
                .catch(error => {
                    app.saveConfigurationPost(app, parent, params);
                })
        },
        sendDataToCart: function (e) {
            e.preventDefault();
            let app = this;
            let parent = app.$parent;
            let errorCounter = 0;

            let name = this.bikeName + ' - ' + this.configKey;
            let description = 'Rahmenfarbe: ' + this.HeaderData['Rahmenfarbe']
                + ', Rahmengröße: ' + this.HeaderData['Rahmengröße']
                + ', Dekor: ' + this.HeaderData['Dekor']
                + ', Klarlack: ' + this.HeaderData['Klarlack'];

            let params =
            {
                "type": "config",
                "name": name,
                "description": description,
                "shortDescription": "",
                "supplier": "tout terrain",
                "image":
                {
                    "href": this.bikeImage || 'https://tout-terrain.de/static/images/placeholder-product.webp',
                    "mediaType": "png"
                }
                ,
                "ordernumber": this.configKey + "-" + this.orderNumber,
                "quantity": 1,
                "price": this.priceRaw,
                "lang": this.$i18n.locale.toUpperCase(),
                "country": this.$parent.countryCode.toUpperCase()
            };

            parent.loading = true;
            app.sendDataToCartPost(app, parent, params, errorCounter);
        },
        sendDataToCartPost: function (app, parent, params, errorCounter) {
            this.$http.post(
                '/curl.php', 
                { 
                    'item': params, 
                    'channel': this.$parent.channel, 
                    'inclVat': this.$parent.vat, 
                    'lang': this.$parent.lang, 
                    'priceSymbol': this.$parent.priceSymbol, 
                    'countryCode': this.$parent.countryCode, 
                    'destination': this.$parent.destination,
                    'shopifyCartSession': {
                        'cartId': this.$parent.cartId,
                        'shopDomain': this.$parent.shopDomain,
                        'locale': this.$i18n.locale
                    }
                })
                .then(response => {
                    const result = response.data.result;
                    const shopifyCartData = response.data.cartData;                    

                    if (result && result.productId) {
                        let domain = "https://tout-terrain.de";
                        if (this.$parent.channel === "b2b") {
                            domain = "https://b2b.tout-terrain.de";
                        }

                        if (this.$i18n.locale === 'de') {
                            window.location.href = domain + '/add?key=' + this.configKey + "&number=" + this.orderNumber
                        } else {
                            window.location.href = domain + '/en/add?key=' + this.configKey + "&number=" + this.orderNumber
                        }
                    } else if(shopifyCartData.success && shopifyCartData.cart.checkoutUrl) {
                        console.log('cartData', shopifyCartData);
                        window.location.href = shopifyCartData.cart.checkoutUrl;
                    }
                })
                .catch(error => {
                    if (error.response.status === 500) {
                        errorCounter++;
                        if (errorCounter <= 25) {
                            setTimeout(function () {
                                app.sendDataToCartPost(app, parent, params, errorCounter);
                            }, 250)
                        }
                    }
                })
        },
        startConfetti: function () {
            class Progress {
                constructor(param = {}) {
                    this.timestamp = null;
                    this.duration = param.duration || Progress.CONST.DURATION;
                    this.progress = 0;
                    this.delta = 0;
                    this.progress = 0;
                    this.isLoop = !!param.isLoop;

                    this.reset();
                }

                static get CONST() {
                    return {
                        DURATION: 1000
                    };
                }

                reset() {
                    this.timestamp = null;
                }

                start(now) {
                    this.timestamp = now;
                }

                tick(now) {
                    if (this.timestamp) {
                        this.delta = now - this.timestamp;
                        this.progress = Math.min(this.delta / this.duration, 1);

                        if (this.progress >= 1 && this.isLoop) {
                            this.start(now);
                        }

                        return this.progress;
                    } else {
                        return 0;
                    }
                }
            }

            class Confetti {
                constructor(param) {
                    this.parent = param.elm || document.body;
                    this.canvas = document.createElement("canvas");
                    this.ctx = this.canvas.getContext("2d");
                    this.width = param.width || this.parent.offsetWidth;
                    this.height = param.height || this.parent.offsetHeight;
                    this.length = param.length || Confetti.CONST.PAPER_LENGTH;
                    this.yRange = param.yRange || this.height * 2;
                    this.progress = new Progress({
                        duration: param.duration,
                        isLoop: true
                    });
                    this.rotationRange = typeof param.rotationLength === "number" ? param.rotationRange
                        : 10;
                    this.speedRange = typeof param.speedRange === "number" ? param.speedRange
                        : 10;
                    this.sprites = [];

                    this.canvas.style.cssText = [
                        "display: block",
                        "position: absolute",
                        "top: 125px",
                        "left: 0",
                        "pointer-events: none"
                    ].join(";");

                    this.render = this.render.bind(this);

                    this.build();

                    //this.parent.appendChild(this.canvas);
                    $('#your_bike').append(this.canvas);
                    this.progress.start(performance.now());

                    requestAnimationFrame(this.render);
                }

                static get CONST() {
                    return {
                        SPRITE_WIDTH: 9,
                        SPRITE_HEIGHT: 16,
                        PAPER_LENGTH: 100,
                        DURATION: 8000,
                        ROTATION_RATE: 50,
                        COLORS: [
                            "#EF5350",
                            "#EC407A",
                            "#AB47BC",
                            "#7E57C2",
                            "#5C6BC0",
                            "#42A5F5",
                            "#29B6F6",
                            "#26C6DA",
                            "#26A69A",
                            "#66BB6A",
                            "#9CCC65",
                            "#D4E157",
                            "#FFEE58",
                            "#FFCA28",
                            "#FFA726",
                            "#FF7043",
                            "#8D6E63",
                            "#BDBDBD",
                            "#78909C"
                        ]
                    };
                }

                build() {
                    for (let i = 0; i < this.length; ++i) {
                        let canvas = document.createElement("canvas"),
                            ctx = canvas.getContext("2d");

                        canvas.width = Confetti.CONST.SPRITE_WIDTH;
                        canvas.height = Confetti.CONST.SPRITE_HEIGHT;

                        canvas.position = {
                            initX: Math.random() * this.width,
                            initY: -canvas.height - Math.random() * this.yRange
                        };

                        canvas.rotation = (this.rotationRange / 2) - Math.random() * this.rotationRange;
                        canvas.speed = (this.speedRange / 2) + Math.random() * (this.speedRange / 2);

                        ctx.save();
                        ctx.fillStyle = Confetti.CONST.COLORS[(Math.random() * Confetti.CONST.COLORS.length) | 0];
                        ctx.fillRect(0, 0, canvas.width, canvas.height);
                        ctx.restore();

                        this.sprites.push(canvas);
                    }
                }

                render(now) {
                    let progress = this.progress.tick(now);

                    this.canvas.width = this.width;
                    this.canvas.height = this.height;

                    for (let i = 0; i < this.length; ++i) {
                        this.ctx.save();
                        this.ctx.translate(
                            this.sprites[i].position.initX + this.sprites[i].rotation * Confetti.CONST.ROTATION_RATE * progress,
                            this.sprites[i].position.initY + progress * (this.height + this.yRange)
                        );
                        this.ctx.rotate(this.sprites[i].rotation);
                        this.ctx.drawImage(
                            this.sprites[i],
                            -Confetti.CONST.SPRITE_WIDTH * Math.abs(Math.sin(progress * Math.PI * 2 * this.sprites[i].speed)) / 2,
                            -Confetti.CONST.SPRITE_HEIGHT / 2,
                            Confetti.CONST.SPRITE_WIDTH * Math.abs(Math.sin(progress * Math.PI * 2 * this.sprites[i].speed)),
                            Confetti.CONST.SPRITE_HEIGHT
                        );
                        this.ctx.restore();
                    }

                    requestAnimationFrame(this.render);
                }
            }

            (() => {
                const DURATION = 3000,
                    LENGTH = 50,
                    HEIGHT = 104;

                this.$nextTick(() => {
                    this.confetti = new Confetti({
                        width: window.innerWidth,
                        height: HEIGHT,
                        length: LENGTH,
                        duration: DURATION
                    });

                    setTimeout(() => {
                        this.confetti2 = new Confetti({
                            width: window.innerWidth,
                            height: HEIGHT,
                            length: LENGTH,
                            duration: DURATION
                        });
                    }, DURATION / 2);
                });
            })();
        },
        handleResize(event) {
            this.$nextTick(() => {
                let width = window.innerWidth;
                this.confetti.width = width;
                this.confetti2.width = width;
            });
        }
    },
    mounted() {
        if (!this.$parent.ConfigurationID) {
            this.$router.push({ path: '/' })
        } else {
            this.$parent.loading = true;
            this.getOverview();
            this.$parent.nav = true;
            this.priceSymbol = this.$parent.priceSymbol;
        }

        window.addEventListener('resize', this.handleResize);

        var a = document.createElement('script');
        a.type = 'text/javascript';
        a.async = true;
        a.src = 'https://cdn.storerocket.io/widget.js';
        var b = document.getElementsByTagName('script')[0];
        b.parentNode.insertBefore(a, b);

        $('#selectModal').on('show.bs.modal', function (event) {
            StoreRocket.init({
                selector: ".storerocket-store-locator",
                account: "QB4LRyz8ej"
            });
        });
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.configurator-your-bike .hiddenButton {
    position: absolute;
    right: 0;
    top: 0;
    width: 100px;
    height: 70px;
}

.configurator-your-bike {
    margin-bottom: 200px;
}

@media print {
    .configurator-your-bike {
        margin-bottom: 0;
    }
}

.configurator-your-bike>>>.configurator-main-title canvas {
    width: 100% !important;
}

.configurator-your-bike>>>.configurator-main-title h1 {
    margin-top: 50px;
    z-index: 1;
    position: relative;
}

.configurator-your-bike .your-bike-sub-title {
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    letter-spacing: 0.29px;
}

.configurator-your-bike .your-bike-merchant {
    border: solid 1px #afb0af;
}

.configurator-your-bike .your-bike-merchant:hover {
    border-color: #ec7205;
}

.configurator-your-bike .your-bike-merchant:hover .your-bike-merchant-icon {
    color: #ec7205;
}

.configurator-your-bike .your-bike-merchant .your-bike-merchant-icon {
    font-size: 27px;
    margin-top: 10px;
}

.configurator-your-bike .your-bike-merchant .your-bike-merchant-title {
    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    letter-spacing: 0.29px;
}

.configurator-your-bike .your-bike-merchant .your-bike-merchant-title-text {
    color: #666666;
    font-size: 13px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.85;
    letter-spacing: 0.21px;
}

.configurator-your-bike .your-bike-merchant .your-bike-merchant-text {
    font-size: 13px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.85;
    letter-spacing: 0.21px;
}

.configurator-your-bike .your-bike-merchant .your-bike-merchant-configurations-number a {
    color: #000000;
    font-size: 24px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.67;
    letter-spacing: 0.38px;
}

.configurator-your-bike .your-bike-merchant .your-bike-merchant-link button {
    color: #ffffff;
    background-color: #000000;
    font-family: 'Roboto Slab', 'Times New Roman', 'Helvetica', 'Arial', serif;
    font-size: 13px;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.38;
    letter-spacing: 0.54px;
    text-align: center;
    border-radius: 0;
}

.configurator-your-bike .your-bike-shopping-cart {
    text-transform: none;
}

.configurator-your-bike .your-bike-shopping-cart .your-bike-shopping-cart-icon {
    font-size: 27px;
    margin-top: 10px;
}

.configurator-your-bike .your-bike-shopping-cart .your-bike-shopping-cart-title {
    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    letter-spacing: 0.29px;
}

.configurator-your-bike .your-bike-shopping-cart .your-bike-shopping-cart-text {
    font-size: 13px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.85;
    letter-spacing: 0.21px;
    white-space: normal;
}

.configurator-your-bike .your-bike-configurations-container {
    background-color: #eeefee;
    text-align: center;
}

.configurator-your-bike .your-bike-configurations-container .your-bike-configurations-number-text {
    font-size: 18px;
    font-weight: bold;
    line-height: 24px;
    letter-spacing: 0.29px;
    margin-bottom: 17px;
}

.configurator-your-bike .your-bike-configurations-container .your-bike-configurations-number {
    font-size: 44px;
    font-weight: bold;
    line-height: 40px;
    letter-spacing: 0.7px;
    margin-bottom: 20px;
}

.configurator-your-bike .your-bike-configurations-container .your-bike-configurations-description {
    font-size: 13px;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0.21px;
    width: 90%;
    margin: 0 auto;
}

.configurator-your-bike .your-bike-configurations-container .your-bike-configurations-comment-text {
    font-size: 15px;
    font-weight: bold;
    line-height: 24px;
    letter-spacing: 0.24px;
    text-transform: uppercase;
    margin-bottom: 10px;
    text-align: left;
}

.configurator-your-bike .your-bike-configurations-container .your-bike-configurations-comment {
    width: 100%;
    height: 80px !important;
    padding: 8px 13px;
    font-size: 13px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0.21px;
    color: #666666;
}

.configurator-your-bike .your-bike-configurations-container .your-bike-configurations-comment-button {
    width: 100%;
    margin-bottom: 15px;
}

.configurator-your-bike .your-bike-configurations-container .your-bike-configurations-print-link {
    font-size: 13px;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0.21px;
}

.configurator-your-bike .your-bike-configurations-container .your-bike-configurations-print-link i {
    font-size: 18px;
}

.configurator-your-bike .your-bike-equipment-container {
    background-color: #eeefee;
    height: 100%;
    font-size: 13px;
    position: relative;
}

.configurator-your-bike .your-bike-equipment-container b {
    font-size: 15px;
    text-transform: uppercase;
}

.configurator-your-bike .your-bike-equipment-container .your-bike-equipment-container-color {
    position: absolute;
    right: 22px;
    top: 22px;
    height: 50px;
    width: 50px;
    border-radius: 100%;
}

.configurator-your-bike .your-bike-item-container {
    background: #eeefee;
    position: relative;
    min-height: 100%;
    height: 100%;
    overflow: hidden;
}

.configurator-your-bike .your-bike-item-container.space-bottom {
    padding-bottom: 195px !important;
}

@media print {
    .configurator-your-bike .your-bike-item-container.space-bottom {
        padding-bottom: 25px !important;
    }
}

.configurator-your-bike .your-bike-item-title {
    font-size: 15px;
    line-height: 24px;
    letter-spacing: 0.24px;
    font-weight: bold;
    text-transform: uppercase;
    color: #ec7205;
}

.configurator-your-bike .your-bike-item-value {
    font-size: 15px;
    line-height: 24px;
    letter-spacing: 0.24px;
    font-weight: bold;
    text-transform: uppercase;
}

.configurator-your-bike .your-bike-item-text {
    font-size: 13px;
    line-height: 1.6;
    font-weight: 500;
    background: #eeefee;
    overflow: hidden;
    position: relative;
    z-index: 1;
    -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    -ms-transition: all 0.3s ease;
    transition: all 0.3s ease;
}

.configurator-your-bike .your-bike-item-price {
    font-size: 13px;
    line-height: 1.6;
    font-weight: 500;
}

.configurator-your-bike .your-bike-item-text.read-more-text {
    height: 85px;
}

.configurator-your-bike .your-bike-item-action-container {
    text-align: center;
    margin-top: 25px;
    margin-bottom: 15px;
}

.configurator-your-bike .your-bike-item-read-less {
    display: none;
    z-index: 1;
    font-family: Roboto Slab;
    font-size: 11px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.64;
    letter-spacing: 0.46px;
    text-transform: uppercase;
    color: #131313;
}

.configurator-your-bike .your-bike-item-read-less i {
    font-size: 16px;
    margin-left: 5px;
}

.configurator-your-bike .your-bike-item-read-more {
    font-family: Roboto Slab;
    font-size: 11px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.64;
    letter-spacing: 0.46px;
    text-transform: uppercase;
    color: #131313;
}

.configurator-your-bike .your-bike-item-read-more i {
    font-size: 16px;
    margin-left: 5px;
}

.configurator-your-bike .your-bike-item-image {
    position: absolute;
    z-index: 0;
    bottom: 1.5rem;
    left: 0;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    width: 100%;
}

.configurator-your-bike .your-bike-item-image img {
    width: 100%;
}

.v-lazy-image {
    opacity: 0;
    transition: opacity 2s;
}

.v-lazy-image-loaded {
    opacity: 1;
}

#selectModal {
    padding-right: 0 !important;
}

#selectModal .modal-dialog {
    max-width: none;
    margin: 0;
    height: 100%;
}

#selectModal .modal-dialog .modal-content {
    height: 100%;
    border-radius: 0;
    border: 0;
}

#selectModal .modal-dialog .modal-content .modal-header .modal-title {
    font-size: 24px;
    font-weight: bold;
    line-height: 1.2;
    letter-spacing: 0.38px;
    text-transform: uppercase;
}

#selectModal .modal-dialog .modal-content .modal-header .close {
    font-size: 10px;
    line-height: 1.2;
    letter-spacing: 0.42px;
    text-align: center;
    color: #131313;
    opacity: 1;
}

#selectModal .modal-dialog .modal-content .modal-header .close:hover {
    color: #ec7205;
}

#selectModal .modal-dialog .modal-content .modal-header .close i {
    font-size: 42px;
    display: block;
}

@media (min-width: 768px) {
    #selectModal .modal-dialog {
        margin: 20px 20px 0 20px;
        height: 95%;
    }
}
</style>